import { confirmAsync } from '../../utils/confirm';
import { DeleteButton } from '../../components/ActionButtons';
import DataTable, { Rozet } from '../../components/DataTable';
import { useState, useEffect, useCallback } from 'react';
import { apiRequest, updateOdaDurum } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

// Oda listesi kolon filtresi kutusu
const HK_FILTRE = 'w-full text-xs font-semibold text-indigo-900 border border-indigo-100/50 rounded-lg px-2.5 py-1.5 focus:outline-none focus:ring-2 focus:ring-indigo-100 bg-white placeholder-indigo-300';

const DURUM_STIL = {
  'Yıkamada':      'bg-amber-50 text-amber-600 border-amber-200',
  'Hazır':         'bg-emerald-50 text-emerald-600 border-emerald-200',
  'Teslim Edildi': 'bg-violet-50 text-violet-600 border-violet-200',
};
const ODEME_TIPLERI = ['NAKİT', 'BANKA HAVALE', 'KREDİ KARTI', 'ÇEK'];

// ── Kirli Listesi Modal ───────────────────────────────────
function KirliListesiModal({ oda, laundryKalemleri, personeller, onClose, onKaydedildi }) {
  const { personel } = useAuth();
  const [kayitlar, setKayitlar]             = useState([]);
  const [yukleniyor, setYukleniyor]         = useState(true);
  const [secilenKalemiId, setSecilenKalemiId] = useState('');
  const [personelId, setPersonelId]         = useState('');
  const [adet, setAdet]                     = useState(1);
  const [ekleniyor, setEkleniyor]           = useState(false);
  const [durumYukleniyor, setDurumYukleniyor] = useState(null); // laundryKayitId

  // Gider onay paneli state
  const [giderOnay, setGiderOnay]           = useState(null); // { kayit, kalemi }
  const [giderOdemeTipi, setGiderOdemeTipi] = useState('NAKİT');
  const [giderKaydediliyor, setGiderKaydediliyor] = useState(false);

  useEffect(() => {
    if (laundryKalemleri.length > 0 && !secilenKalemiId) {
      setSecilenKalemiId(laundryKalemleri[0].laundryKalemiId);
    }
  }, [laundryKalemleri]);

  const fetchKayitlar = useCallback(async () => {
    if (!oda?.odaId) return;
    setYukleniyor(true);
    try {
      const data = await apiRequest(`laundry-kayit/oda/${oda.odaId}`);
      setKayitlar(data || []);
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }, [oda?.odaId]);

  useEffect(() => { fetchKayitlar(); }, [fetchKayitlar]);

  async function handleEkle() {
    if (!secilenKalemiId) return;
    setEkleniyor(true);
    try {
      await apiRequest('laundry-kayit', 'POST', {
        odaId:           oda.odaId,
        laundryKalemiId: parseInt(secilenKalemiId),
        personelId:      personelId ? parseInt(personelId) : null,
        otelId:          personel?.otelId ?? 0,
        adet:            parseInt(adet) || 1,
        durum:           'Yıkamada',
      });
      await fetchKayitlar();
      onKaydedildi?.();
      setAdet(1);
    } catch (e) { alert(e?.message || 'Kayıt eklenemedi.'); }
    setEkleniyor(false);
  }

  async function handleDurumGuncelle(kayit, yeniDurum) {
    if (kayit.durum === yeniDurum) return;
    setDurumYukleniyor(kayit.laundryKayitId);
    try {
      await apiRequest(`laundry-kayit/${kayit.laundryKayitId}/durum`, 'PUT', { durum: yeniDurum });
      await fetchKayitlar();
      onKaydedildi?.();
      // Teslim Edildi → birim fiyat varsa gider onayı sor
      if (yeniDurum === 'Teslim Edildi') {
        const kalemi = laundryKalemleri.find(k => k.laundryKalemiId === kayit.laundryKalemiId);
        if (kalemi?.fiyat > 0) {
          setGiderOnay({ kayit, kalemi });
          setGiderOdemeTipi('NAKİT');
        }
      }
    } catch (e) { alert(e?.message || 'Durum güncellenemedi.'); }
    setDurumYukleniyor(null);
  }

  async function handleGiderOlustur() {
    if (!giderOnay) return;
    setGiderKaydediliyor(true);
    try {
      const { kayit, kalemi } = giderOnay;
      await apiRequest(`laundry-kayit/${kayit.laundryKayitId}/durum`, 'PUT', {
        durum:         'Teslim Edildi',
        giderOlustur:  true,
        birimFiyat:    kalemi.fiyat,
        adet:          kayit.adet,
        kalemiAd:      kalemi.ad,
        odaNo:         kayit.odaNo || oda.odaNo,
        odemeTipi:     giderOdemeTipi,
      });
      setGiderOnay(null);
    } catch (e) { alert(e?.message || 'Gider kaydedilemedi.'); }
    setGiderKaydediliyor(false);
  }

  async function handleSil(id) {
    try {
      await apiRequest(`laundry-kayit/${id}`, 'DELETE');
      await fetchKayitlar();
      onKaydedildi?.();
    } catch (e) { alert(e?.message || 'Silinemedi.'); }
  }

  const fmtTarih = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
  };

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-[200] flex items-end sm:items-start justify-center sm:pt-16 sm:px-4 animate-fadeIn" onClick={onClose}>
      <div className="bg-white w-full max-w-4xl rounded-t-[2.5rem] sm:rounded-[2.5rem] shadow-2xl overflow-hidden animate-scaleIn origin-bottom sm:origin-top"
        style={{ maxHeight:'90vh', display:'flex', flexDirection:'column' }}
        onClick={e => e.stopPropagation()}>
        
        {/* Drag handle (mobil) */}
        <div className="flex justify-center pt-4 pb-2 sm:hidden flex-shrink-0">
          <div className="w-12 h-1.5 bg-gray-200 rounded-full"/>
        </div>

        {/* ── Header ── */}
        <div className="flex items-center justify-between px-4 sm:px-8 py-4 sm:py-6 border-b border-gray-100 flex-shrink-0 bg-gray-50/50">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-indigo-50 flex items-center justify-center text-indigo-500 text-xl shadow-sm border border-indigo-100/50">
              🧺
            </div>
            <div>
              <h3 className="font-black text-gray-800 text-xl tracking-tight">Oda {oda.odaNo}</h3>
              <div className="flex flex-wrap items-center gap-2 mt-1">
                <span className={`text-[9px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg border ${oda.durum==='Kirli' ? 'bg-rose-50 border-rose-100 text-rose-600' : oda.durum==='Dolu' ? 'bg-blue-50 border-blue-100 text-blue-600' : 'bg-emerald-50 border-emerald-100 text-emerald-600'}`}>
                  {oda.durum}
                </span>
                {oda.arizaliMi && (
                  <span className="text-[9px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg bg-amber-50 border border-amber-100 text-amber-600 flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"/> Arızalı
                  </span>
                )}
              </div>
            </div>
          </div>
          <button onClick={onClose} className="w-10 h-10 bg-white hover:bg-rose-50 hover:text-rose-500 border border-gray-200 rounded-2xl flex items-center justify-center text-gray-400 font-bold transition-all shadow-sm">✕</button>
        </div>

        {/* ── Ekleme formu ── */}
        <div className="px-4 sm:px-8 py-3 sm:py-6 border-b border-gray-100 flex-shrink-0 bg-white">
          <div className="grid grid-cols-2 sm:grid-cols-[1.5fr_1.5fr_auto_auto] gap-3 items-end">
            <div>
              <label className="text-[10px] font-black text-indigo-900/60 uppercase tracking-widest mb-2 block pl-1">Laundry Kalemi</label>
              <select
                value={secilenKalemiId}
                onChange={e => setSecilenKalemiId(Number(e.target.value))}
                className="w-full border border-gray-200 rounded-2xl px-4 py-3.5 text-sm font-semibold text-gray-700 bg-gray-50 focus:bg-white hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-100 transition-colors shadow-sm appearance-none cursor-pointer">
                {laundryKalemleri.map(k => (
                  <option key={k.laundryKalemiId} value={k.laundryKalemiId}>{k.ad}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-indigo-900/60 uppercase tracking-widest mb-2 block pl-1">Sorumlu Personel</label>
              <select
                value={personelId}
                onChange={e => setPersonelId(e.target.value)}
                className="w-full border border-gray-200 rounded-2xl px-4 py-3.5 text-sm font-semibold text-gray-700 bg-gray-50 focus:bg-white hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-100 transition-colors shadow-sm appearance-none cursor-pointer">
                <option value="">— Seçiniz —</option>
                {(personeller || []).map(p => (
                  <option key={p.personelId} value={p.personelId}>{p.adSoyad}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-[10px] font-black text-indigo-900/60 uppercase tracking-widest mb-2 block pl-1">Adet</label>
              <div className="flex items-center border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm h-[52px]">
                <input type="number" value={adet} onChange={e => setAdet(Math.max(1, Number(e.target.value)))}
                  className="w-20 px-4 py-0 h-full text-center font-black text-gray-700 focus:outline-none bg-gray-50 focus:bg-white border-r border-gray-200" style={{ MozAppearance:'textfield' }}/>
                <div className="flex flex-col h-full w-10 divide-y divide-gray-200">
                  <button onClick={() => setAdet(a => a+1)} className="flex-1 bg-white hover:bg-indigo-50 text-indigo-500 font-black text-sm flex items-center justify-center transition-colors">+</button>
                  <button onClick={() => setAdet(a => Math.max(1,a-1))} className="flex-1 bg-white hover:bg-rose-50 text-rose-500 font-black text-sm flex items-center justify-center transition-colors">-</button>
                </div>
              </div>
            </div>
            <button onClick={handleEkle} disabled={ekleniyor || !secilenKalemiId}
              className="h-[52px] bg-gradient-to-r from-indigo-500 to-violet-500 hover:opacity-90 disabled:opacity-60 text-white px-8 rounded-2xl text-[11px] font-black uppercase tracking-widest transition-all shadow-xl hover:-translate-y-0.5">
              {ekleniyor ? '⌛' : 'LİSTEYE EKLE'}
            </button>
          </div>
        </div>

        {/* ── Gider Onay Paneli ── */}
        {giderOnay && (
          <div className="px-4 sm:px-8 py-4 border-t border-amber-100 bg-amber-50/60 flex-shrink-0 animate-fadeIn">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex items-start gap-3 flex-1">
                <div className="w-9 h-9 rounded-xl bg-amber-100 flex items-center justify-center text-amber-600 text-base flex-shrink-0 mt-0.5">💰</div>
                <div>
                  <p className="font-black text-amber-800 text-sm tracking-tight">Gider kaydı oluşturulsun mu?</p>
                  <p className="text-[10px] font-bold text-amber-600 mt-0.5">
                    {giderOnay.kayit.adet} × {giderOnay.kalemi.ad} — {(giderOnay.kalemi.fiyat * giderOnay.kayit.adet).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <select
                  value={giderOdemeTipi}
                  onChange={e => setGiderOdemeTipi(e.target.value)}
                  className="border border-amber-200 rounded-xl px-3 py-2 text-[10px] font-black text-amber-800 bg-white focus:outline-none focus:border-amber-400 cursor-pointer uppercase tracking-widest">
                  {ODEME_TIPLERI.map(t => <option key={t}>{t}</option>)}
                </select>
                <button
                  onClick={handleGiderOlustur}
                  disabled={giderKaydediliyor}
                  className="bg-amber-500 hover:bg-amber-600 disabled:opacity-60 text-white text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-xl transition-all shadow-sm">
                  {giderKaydediliyor ? '⌛' : 'EVET, OLUŞTUR'}
                </button>
                <button
                  onClick={() => setGiderOnay(null)}
                  className="bg-white hover:bg-amber-50 text-amber-600 border border-amber-200 text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-xl transition-all">
                  HAYIR
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Kayıt listesi ── */}
        <div className="flex-1 overflow-y-auto bg-gray-50/50 p-3 sm:p-6">
          {yukleniyor ? (
            <div className="text-center py-12 text-gray-400">
              <div className="text-3xl mb-3 animate-bounce">🧺</div>
              <p className="text-[11px] font-black uppercase tracking-widest">Yükleniyor...</p>
            </div>
          ) : kayitlar.length === 0 ? (
            <div className="text-center py-12 text-gray-400">
              <div className="text-4xl mb-3 opacity-30">✨</div>
              <p className="text-[11px] font-black uppercase tracking-widest">Bu oda için laundry kaydı bulunmuyor</p>
            </div>
          ) : (
            <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
              {/* Masaüstü: tablo */}
              <div className="hidden sm:block overflow-x-auto">
                <DataTable
                  anahtarAlan="laundryKayitId"
                  satirlar={kayitlar}
                  bosIkon="🧺"
                  bosMetin="Laundry kaydı bulunamadı"
                  kolonlar={[
                    {
                      anahtar: 'laundryKalemiAd', baslik: 'Laundry Kalemi', siralanir: true, filtrelenir: true,
                      ciz: k => (
                        <span className="font-bold text-gray-800 text-sm tracking-tight">
                          {k.laundryKalemiAd}
                          {k.birimFiyat > 0 && (
                            <span className="ml-2 text-[9px] font-black text-emerald-600 bg-emerald-50 border border-emerald-100 px-1.5 py-0.5 rounded-md">
                              {k.birimFiyat.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺/adet
                            </span>
                          )}
                        </span>
                      ),
                    },
                    {
                      anahtar: 'adet', baslik: 'Adet', hizala: 'orta', siralanir: true,
                      ciz: k => <span className="text-indigo-600 font-black text-sm">{k.adet}</span>,
                    },
                    {
                      anahtar: 'durum', baslik: 'Durum', siralanir: true,
                      ciz: k => (
                        <div className="flex gap-1">
                          {['Yıkamada', 'Hazır', 'Teslim Edildi'].map(d => (
                            <button key={d}
                              disabled={durumYukleniyor === k.laundryKayitId}
                              onClick={() => handleDurumGuncelle(k, d)}
                              className={'text-[8px] font-black uppercase tracking-widest px-2 py-1 rounded-lg border transition-all ' +
                                (k.durum === d
                                  ? DURUM_STIL[d] + ' opacity-100'
                                  : 'bg-gray-50 text-gray-400 border-gray-100 hover:border-gray-300 opacity-60 hover:opacity-100')}>
                              {durumYukleniyor === k.laundryKayitId && k.durum !== d ? '…' : d}
                            </button>
                          ))}
                        </div>
                      ),
                    },
                    {
                      anahtar: 'kayitTarihi', baslik: 'Tarih', siralanir: true,
                      ciz: k => <span className="text-gray-400 text-xs font-semibold whitespace-nowrap">{fmtTarih(k.kayitTarihi)}</span>,
                    },
                    {
                      anahtar: 'aksiyon', baslik: 'Aksiyon', hizala: 'sag',
                      ciz: k => <DeleteButton onClick={() => handleSil(k.laundryKayitId)} />,
                    },
                  ]}
                />
              </div>
              {/* Mobil: kartlar */}
              <div className="sm:hidden flex flex-col divide-y divide-gray-50">
                {kayitlar.map(k => (
                  <div key={k.laundryKayitId} className="p-5 flex flex-col gap-3 hover:bg-gray-50 transition-colors">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <p className="font-bold text-gray-800 text-sm tracking-tight">{k.laundryKalemiAd}</p>
                        <p className="text-[10px] font-black text-gray-400 mt-1 uppercase tracking-widest">{fmtTarih(k.kayitTarihi)}</p>
                        {k.birimFiyat > 0 && (
                          <p className="text-[9px] font-black text-emerald-600 mt-1">{k.birimFiyat.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺/adet</p>
                        )}
                      </div>
                      <span className="bg-indigo-50 text-indigo-600 border border-indigo-100 text-[10px] font-black px-2.5 py-1 rounded-lg">
                        {k.adet} Adet
                      </span>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {['Yıkamada', 'Hazır', 'Teslim Edildi'].map(d => (
                        <button key={d} disabled={durumYukleniyor === k.laundryKayitId}
                          onClick={() => handleDurumGuncelle(k, d)}
                          className={`text-[8px] font-black uppercase tracking-widest px-2.5 py-1.5 rounded-lg border transition-all flex-1
                            ${k.durum === d ? DURUM_STIL[d] + ' shadow-sm' : 'bg-gray-50 text-gray-400 border-gray-100 hover:border-gray-300'}`}>
                          {d}
                        </button>
                      ))}
                    </div>
                    <div className="flex justify-end">
                      <button onClick={() => handleSil(k.laundryKayitId)}
                        className="bg-white hover:bg-rose-50 text-gray-400 hover:text-rose-500 border border-gray-200 hover:border-rose-200 text-[10px] font-black uppercase tracking-widest px-4 py-1.5 rounded-xl transition-all shadow-sm">
                        SİL
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Ana Housekeeping Modal ────────────────────────────────
export default function HousekeepingModal({ onClose }) {
  const [odalar, setOdalar]               = useState([]);
  const [laundryKalemleri, setLaundryKalemleri] = useState([]);
  const [personeller, setPersoneller]     = useState([]);
  const [laundryOzet, setLaundryOzet]     = useState([]);
  const [yukleniyor, setYukleniyor]       = useState(true);
  const [aktifFiltre, setAktifFiltre]     = useState('Hepsi');
  const [araAdi, setAraAdi]               = useState('');
  const [araTip, setAraTip]               = useState('');
  const [araDurum, setAraDurum]           = useState('');
  const [kirliModalOda, setKirliModalOda] = useState(null);
  const [arizaNedenModal, setArizaNedenModal] = useState(null); // oda objesi
  const [arizaNedenInput, setArizaNedenInput] = useState('');
  const [arizaTooltip, setArizaTooltip] = useState(null); // odaId göster tooltip

  const fetchVeriler = useCallback(async () => {
    setYukleniyor(true);
    try {
      const [odaData, kalemiData, kayitData, personelData] = await Promise.all([
        apiRequest('oda'),
        apiRequest('LaundryKalemi'),
        apiRequest('laundry-kayit'),
        apiRequest('personeller'),
      ]);
      setOdalar((odaData || []).sort((a,b) => a.odaNo?.localeCompare(b.odaNo, 'tr', {numeric:true})));
      setLaundryKalemleri((kalemiData || []).filter(k => k.aktifMi !== false));
      setPersoneller((personelData || []).filter(p => p.aktifMi !== false));

      // Laundry özet — kaleme göre toplam adet + hangi odalar
      const ozet = {};
      (kayitData || []).forEach(k => {
        const ad = k.laundryKalemiAd || `Kalem #${k.laundryKalemiId}`;
        if (!ozet[ad]) ozet[ad] = { toplam: 0, odalar: [] };
        ozet[ad].toplam += k.adet;
        
        let eOdaNo = k.odaNo;
        if (!eOdaNo && k.odaId && odaData) {
          const matchedOda = odaData.find(o => o.odaId === k.odaId);
          if (matchedOda) eOdaNo = matchedOda.odaNo;
        }

        if (eOdaNo) {
          const mevcut = ozet[ad].odalar.find(o => o.odaNo === eOdaNo);
          if (mevcut) mevcut.adet += k.adet;
          else ozet[ad].odalar.push({ odaNo: eOdaNo, adet: k.adet });
        }
      });
      setLaundryOzet(Object.entries(ozet).map(([ad, v]) => ({ ad, toplam: v.toplam, odalar: v.odalar })).sort((a,b) => a.ad.localeCompare(b.ad,'tr')));
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => { fetchVeriler(); }, [fetchVeriler]);

  async function handleDurumDegis(oda, yeniDurum) {
    setOdalar(prev => prev.map(o => o.odaId === oda.odaId ? {...o, durum: yeniDurum} : o));
    try {
      await updateOdaDurum(oda.odaId, yeniDurum);
    } catch {
      setOdalar(prev => prev.map(o => o.odaId === oda.odaId ? {...o, durum: oda.durum} : o));
      alert('Durum güncellenemedi.');
    }
  }

  async function handleArizaliDegis(oda, arizaliMi, arizaNedeni) {
    setOdalar(prev => prev.map(o => o.odaId === oda.odaId ? {...o, arizaliMi, arizaNedeni: arizaliMi ? arizaNedeni : null} : o));
    try {
      await apiRequest(`oda/${oda.odaId}/arizali`, 'PATCH', { arizaliMi, arizaNedeni });
    } catch {
      setOdalar(prev => prev.map(o => o.odaId === oda.odaId ? {...o, arizaliMi: oda.arizaliMi, arizaNedeni: oda.arizaNedeni} : o));
      alert('Arıza durumu güncellenemedi.');
    }
  }

  async function handleTumunuTemizle() {
    if (!(await confirmAsync())) return;
    const kirliOdalar = odalar.filter(o => o.durum === 'Kirli');
    try {
      await Promise.all(kirliOdalar.map(o => apiRequest(`oda/${o.odaId}/durum`, 'PATCH', { durum: 'Temiz' })));
      await fetchVeriler();
    } catch {
      await fetchVeriler();
      alert('Bazı odalar güncellenemedi.');
    }
  }

  const filtreli = odalar.filter(o => {
    if (aktifFiltre === 'Kirli'   && o.durum !== 'Kirli')   return false;
    if (aktifFiltre === 'Arızalı' && !o.arizaliMi)          return false;
    if (aktifFiltre === 'Temiz'   && o.durum !== 'Temiz')     return false;
    if (aktifFiltre === 'Dolu'    && o.durum !== 'Dolu')     return false;
    if (araAdi   && !o.odaNo?.toLocaleLowerCase('tr-TR').includes(araAdi.toLocaleLowerCase('tr-TR')))   return false;
    if (araTip   && !o.odaTipiAd?.toLocaleLowerCase('tr-TR').includes(araTip.toLocaleLowerCase('tr-TR'))) return false;
    if (araDurum && !o.durum?.toLocaleLowerCase('tr-TR').includes(araDurum.toLocaleLowerCase('tr-TR'))) return false;
    return true;
  });

  const sayilar = {
    toplam:  odalar.length,
    bos:     odalar.filter(o => o.durum === 'Temiz').length,
    dolu:    odalar.filter(o => o.durum === 'Dolu').length,
    kirli:   odalar.filter(o => o.durum === 'Kirli').length,
    arizali: odalar.filter(o => o.arizaliMi).length,
  };

  const filtreler = [
    { label:'Hepsi',   count: sayilar.toplam,  color:'bg-gray-500 hover:bg-gray-600'   },
    { label:'Temiz',   count: sayilar.bos,     color:'bg-emerald-500 hover:bg-emerald-600' },
    { label:'Dolu',    count: sayilar.dolu,     color:'bg-blue-500 hover:bg-blue-600'    },
    { label:'Kirli',   count: sayilar.kirli,    color:'bg-red-500 hover:bg-red-600'      },
    { label:'Arızalı', count: sayilar.arizali,  color:'bg-amber-500 hover:bg-amber-600'  },
  ];

  function satirBg(oda) {
    if (oda.durum === 'Kirli' && oda.arizaliMi) return '#fef3c7'; // hem kirli hem arızalı → amber
    if (oda.durum === 'Kirli')   return '#fef2f2';
    if (oda.arizaliMi)           return '#fffbeb';
    if (oda.durum === 'Dolu')    return '#eff6ff';
    return undefined;
  }

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-[150] flex items-start justify-center pt-6 px-4 animate-fadeIn" onClick={onClose}>
      <div className="bg-white w-full max-w-6xl rounded-t-[2.5rem] sm:rounded-[2.5rem] shadow-2xl overflow-hidden animate-scaleIn origin-top"
        style={{ maxHeight:'92vh', display:'flex', flexDirection:'column' }}
        onClick={e => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="flex items-center justify-between px-8 py-6 bg-[#0f172a] relative overflow-hidden flex-shrink-0">
          <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/20 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/3 pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-500/20 rounded-full blur-[60px] translate-y-1/2 -translate-x-1/2 pointer-events-none" />
          
          <div className="flex items-center gap-4 relative z-10">
            <div className="w-14 h-14 bg-white/10 backdrop-blur-md rounded-2xl border border-white/10 flex items-center justify-center text-2xl shadow-xl">
              🧹
            </div>
            <div>
              <h3 className="font-black text-white text-2xl tracking-tighter">Oda Durumları & Temizlik</h3>
              <p className="text-indigo-300 text-[11px] font-black uppercase tracking-widest mt-1 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full animate-pulse" />
                {sayilar.kirli} Kirli · {sayilar.arizali} Arızalı · {sayilar.bos} Temiz
              </p>
            </div>
          </div>
          <button onClick={onClose} className="w-10 h-10 bg-white/5 hover:bg-rose-500 text-white rounded-2xl flex items-center justify-center font-bold transition-colors relative z-10 border border-white/10 shadow-lg backdrop-blur-md">✕</button>
        </div>

        {/* ── Filtreler ── */}
        <div className="px-4 sm:px-8 py-3 border-b border-gray-100 flex items-center gap-2 flex-wrap flex-shrink-0 bg-gray-50/50 backdrop-blur-md">
          <div className="flex flex-wrap gap-1.5">
            {filtreler.map(f => {
              const baseColor = f.label === 'Hepsi' ? 'from-gray-500 to-gray-600' :
                                f.label === 'Temiz' ? 'from-emerald-500 to-teal-500' :
                                f.label === 'Dolu' ? 'from-blue-500 to-indigo-500' :
                                f.label === 'Kirli' ? 'from-red-500 to-rose-500' :
                                'from-amber-500 to-orange-500';

              const activeClass = aktifFiltre === f.label
                ? `bg-gradient-to-r ${baseColor} text-white shadow-md scale-105`
                : 'bg-white text-gray-500 border border-gray-200 hover:border-gray-300 hover:bg-gray-50';

              return (
                <button key={f.label} onClick={() => setAktifFiltre(f.label)}
                  className={`px-2.5 sm:px-4 py-1.5 rounded-lg sm:rounded-xl text-[10px] sm:text-[11px] font-black uppercase tracking-widest transition-all flex items-center gap-1.5 ${activeClass}`}>
                  {f.label}
                  <span className={`px-1 sm:px-1.5 py-0.5 rounded-md text-[8px] sm:text-[9px] ${aktifFiltre === f.label ? 'bg-white/20' : 'bg-gray-100 text-gray-600'}`}>
                    {f.count}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="mt-1 sm:mt-0 sm:ml-auto flex items-center gap-2">
            <button onClick={handleTumunuTemizle}
              className="bg-indigo-50 text-indigo-600 border border-indigo-100 hover:bg-indigo-600 hover:text-white px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all shadow-sm flex items-center gap-1.5 group">
              <span className="group-hover:scale-110 transition-transform">🧹</span> Kirli → Temiz
            </button>
            <button onClick={fetchVeriler}
              className="w-10 h-10 border border-gray-200 bg-white hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-600 text-gray-400 rounded-xl flex items-center justify-center transition-all shadow-sm" title="Yenile">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
            </button>
          </div>
        </div>

        {/* İçerik */}
        <div className="flex-1 overflow-y-auto">
          {yukleniyor ? (
            <div className="text-center py-16 text-gray-400">
              <div className="text-3xl mb-2 animate-spin inline-block">⟳</div>
              <p>Yükleniyor...</p>
            </div>
          ) : (
            <>
              {/* Oda listesi */}
              <div className="px-8 pt-6 pb-2">
                <div className="flex items-center justify-between mb-4">
                  <h4 className="font-bold text-gray-800 text-lg tracking-tight">Oda Listesi</h4>
                  <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100">{filtreli.length} KALEM</span>
                </div>

                {/* Mobil arama kutuları */}
                <div className="sm:hidden grid grid-cols-2 gap-3 mb-4">
                  <input value={araAdi} onChange={e => setAraAdi(e.target.value)} placeholder="Oda no ara..."
                    className="text-xs border border-gray-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-100 bg-gray-50/50"/>
                  <input value={araDurum} onChange={e => setAraDurum(e.target.value)} placeholder="Durum ara..."
                    className="text-xs border border-gray-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-100 bg-gray-50/50"/>
                </div>

                <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">

                  {/* Masaüstü: tablo */}
                  <div className="hidden sm:block overflow-x-auto custom-scrollbar">
                    <DataTable
                      anahtarAlan="odaId"
                      satirlar={filtreli}
                      bosIkon="🔍"
                      bosMetin="Kayıt bulunamadı"
                      satirStil={oda => ({ backgroundColor: satirBg(oda) })}
                      kolonlar={[
                        {
                          anahtar: 'odaNo', baslik: 'Oda No', siralanir: true,
                          baslikAlti: () => (
                            <input value={araAdi} onChange={e => setAraAdi(e.target.value)}
                              placeholder="Oda ara..." className={HK_FILTRE} />
                          ),
                          ciz: oda => <span className="font-black text-gray-800 text-lg tracking-tight">{oda.odaNo}</span>,
                        },
                        {
                          anahtar: 'odaTipiAd', baslik: 'Oda Tipi', siralanir: true,
                          baslikAlti: () => (
                            <input value={araTip} onChange={e => setAraTip(e.target.value)}
                              placeholder="Tip ara..." className={HK_FILTRE} />
                          ),
                          ciz: oda => (
                            <span className="bg-white border border-gray-100 text-[10px] font-black text-gray-500 uppercase tracking-widest px-2.5 py-1 rounded-lg">
                              {oda.odaTipiAd || '—'}
                            </span>
                          ),
                        },
                        {
                          anahtar: 'odaGrubuAd', baslik: 'Grup', siralanir: true,
                          ciz: oda => <span className="text-gray-400 text-xs font-semibold">{oda.odaGrubuAd || '—'}</span>,
                        },
                        {
                          anahtar: 'durum', baslik: 'Durum / Etiketler', siralanir: true,
                          baslikAlti: () => (
                            <input value={araDurum} onChange={e => setAraDurum(e.target.value)}
                              placeholder="Durum ara..." className={HK_FILTRE} />
                          ),
                          ciz: oda => (
                            <div className="flex items-center gap-2 flex-wrap">
                              <Rozet renk={
                                oda.durum === 'Temiz' ? 'emerald'
                                : oda.durum === 'Dolu' ? 'indigo'
                                : oda.durum === 'Kirli' ? 'rose' : 'gray'
                              }>{oda.durum}</Rozet>
                              {oda.arizaliMi && (
                                <span className="max-w-[150px]" title={oda.arizaNedeni}>
                                  <Rozet renk="amber">
                                    <span className="truncate">🔧 Arızalı{oda.arizaNedeni ? ` — ${oda.arizaNedeni}` : ''}</span>
                                  </Rozet>
                                </span>
                              )}
                            </div>
                          ),
                        },
                        {
                          anahtar: 'aksiyon', baslik: 'Aksiyon',
                          ciz: oda => (
                            <button onClick={() => setKirliModalOda(oda)}
                              className="bg-indigo-50 hover:bg-indigo-600 text-indigo-600 hover:text-white border border-indigo-100 text-[10px] font-black uppercase tracking-widest px-3 py-2 rounded-xl transition-all flex items-center gap-1.5">
                              🧺 Kirliler
                            </button>
                          ),
                        },
                        {
                          anahtar: 'durumYonetimi', baslik: 'Durum Yönetimi',
                          ciz: oda => oda.durum === 'Dolu' ? (
                            <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest bg-gray-50 px-2 py-1 rounded">
                              Aktif rezervasyon
                            </span>
                          ) : (
                            <div className="flex items-center gap-5">
                              <div className="flex bg-white border border-gray-100 p-1 rounded-xl">
                                {['Temiz', 'Kirli'].map(d => (
                                  <label key={d}
                                    className={'flex items-center gap-1.5 cursor-pointer px-3 py-1.5 rounded-lg transition-colors ' +
                                      (oda.durum === d
                                        ? (d === 'Temiz' ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-600')
                                        : 'hover:bg-gray-50 text-gray-400')}>
                                    <input type="radio" name={`durum-${oda.odaId}`} checked={oda.durum === d}
                                      onChange={() => handleDurumDegis(oda, d)} className="hidden" />
                                    <div className={'w-3 h-3 rounded-full border-2 flex items-center justify-center ' +
                                      (oda.durum === d
                                        ? (d === 'Temiz' ? 'border-emerald-500' : 'border-rose-500')
                                        : 'border-gray-300')}>
                                      {oda.durum === d && (
                                        <div className={'w-1.5 h-1.5 rounded-full ' + (d === 'Temiz' ? 'bg-emerald-500' : 'bg-rose-500')} />
                                      )}
                                    </div>
                                    <span className="text-[10px] font-black uppercase tracking-widest">{d}</span>
                                  </label>
                                ))}
                              </div>
                              <label className="flex items-center gap-2 cursor-pointer">
                                <input type="checkbox" checked={!!oda.arizaliMi}
                                  onChange={e => {
                                    if (e.target.checked) { setArizaNedenInput(''); setArizaNedenModal(oda); }
                                    else handleArizaliDegis(oda, false, null);
                                  }}
                                  className="w-4 h-4 cursor-pointer accent-amber-500 rounded" />
                                <span className="text-[10px] font-black uppercase tracking-widest text-amber-600/70">🔧 Arıza işle</span>
                              </label>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>

                  {/* Mobil: kartlar */}
                  <div className="sm:hidden flex flex-col divide-y divide-gray-50">
                    {filtreli.length === 0 ? (
                      <div className="text-center py-10 text-gray-400"><div className="text-3xl mb-2">🔍</div>Kayıt bulunamadı</div>
                    ) : filtreli.map(oda => (
                      <div key={oda.odaId} className="p-5 transition-colors flex flex-col gap-3" style={{ backgroundColor: satirBg(oda) }}>
                        <div className="flex items-start justify-between">
                          <div>
                            <p className="font-black text-gray-800 text-lg">Oda {oda.odaNo}</p>
                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-1">{oda.odaTipiAd || '—'}{oda.odaGrubuAd ? ` · ${oda.odaGrubuAd}` : ''}</p>
                          </div>
                          <div className="flex flex-col items-end gap-1.5">
                            <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[9px] font-black uppercase tracking-widest shadow-sm ${
                              oda.durum === 'Temiz' ? 'bg-emerald-50 border border-emerald-100 text-emerald-600' :
                              oda.durum === 'Dolu' ? 'bg-blue-50 border border-blue-100 text-blue-600' :
                              oda.durum === 'Kirli' ? 'bg-rose-50 border border-rose-100 text-rose-600' :
                              'bg-gray-50 border border-gray-200 text-gray-600'
                            }`}>{oda.durum}</span>
                            {oda.arizaliMi && (
                              <div className="relative">
                                <button
                                  onClick={() => setArizaTooltip(arizaTooltip === oda.odaId ? null : oda.odaId)}
                                  className="inline-flex items-center gap-1 px-2 py-0.5 rounded-lg bg-amber-50 border border-amber-100 text-amber-600 text-[9px] font-black uppercase tracking-widest shadow-sm">
                                  🔧 Arızalı
                                  {oda.arizaNedeni && <span className="w-4 h-4 bg-amber-100 rounded-full text-[9px] flex items-center justify-center font-black">?</span>}
                                </button>
                                {arizaTooltip === oda.odaId && oda.arizaNedeni && (
                                  <div className="absolute right-0 top-full mt-1 z-50 bg-amber-900 text-amber-50 text-xs font-semibold rounded-xl px-3 py-2 shadow-2xl max-w-[200px] min-w-[120px]" onClick={() => setArizaTooltip(null)}>
                                    {oda.arizaNedeni}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="bg-white/50 rounded-xl p-3 border border-gray-100 flex flex-col gap-3">
                          {oda.durum === 'Dolu' ? (
                            <div className="bg-gray-100 text-[10px] font-black uppercase text-gray-400 py-2 rounded-lg text-center tracking-widest">Aktif rezervasyon</div>
                          ) : (
                            <div className="flex items-center gap-2 justify-between">
                              <div className="flex bg-white border border-gray-100 shadow-sm p-1 rounded-lg flex-1">
                                {['Temiz','Kirli'].map(d => (
                                  <label key={d} className={`flex-1 flex justify-center items-center gap-1 cursor-pointer py-1.5 rounded-md transition-colors ${oda.durum === d ? (d==='Temiz' ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-600') : 'text-gray-400'}`}>
                                    <input type="radio" name={`durum-mob-${oda.odaId}`} checked={oda.durum === d} onChange={() => handleDurumDegis(oda, d)} className="hidden"/>
                                    <span className="text-[10px] font-black uppercase tracking-widest">{d}</span>
                                  </label>
                                ))}
                              </div>
                              <label className="flex items-center gap-1 cursor-pointer p-2 rounded-lg border border-amber-100 bg-amber-50">
                                <input type="checkbox" checked={!!oda.arizaliMi} onChange={e => { if (e.target.checked) { setArizaNedenInput(''); setArizaNedenModal(oda); } else handleArizaliDegis(oda, false, null); }} className="w-3.5 h-3.5 cursor-pointer accent-amber-500 rounded"/>
                                <span className="text-[9px] font-black uppercase tracking-widest text-amber-600/70">Arızalı</span>
                              </label>
                            </div>
                          )}
                          <button onClick={() => setKirliModalOda(oda)} className="w-full bg-indigo-50 text-indigo-600 border border-indigo-100 text-[10px] font-black uppercase tracking-widest px-3 py-2 rounded-lg shadow-sm">
                            🧺 Kirliler Detayı
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>

              {/* Laundry özet */}
              <div className="px-8 py-8 border-t border-gray-100 bg-gray-50/30">
                <h4 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <span className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-500 shadow-sm">🧺</span>
                  Mevcut Laundry Özeti
                </h4>
                {laundryOzet.length === 0 ? (
                  <div className="bg-white rounded-2xl border border-gray-100 py-10 text-center text-gray-400 text-sm shadow-sm">
                    <div className="text-3xl mb-3 opacity-30">✨</div>
                    Bekleyen veya isleme alınmış laundry kaydı yok
                  </div>
                ) : (
                  <div className="rounded-2xl border border-gray-100 overflow-hidden shadow-sm bg-white">
                    {/* Masaüstü: tablo */}
                    <div className="hidden sm:block">
                      <DataTable
                        anahtarAlan="ad"
                        satirlar={laundryOzet}
                        bosIkon="🧺"
                        bosMetin="Özet için kayıt yok"
                        kolonlar={[
                          {
                            anahtar: 'ad', baslik: 'Laundry Kalemi', siralanir: true,
                            ciz: item => <span className="text-gray-800 font-bold text-sm tracking-tight">{item.ad}</span>,
                          },
                          {
                            anahtar: 'odalar', baslik: 'Odalar ve Dağılımı',
                            ciz: item => (
                              <div className="flex flex-wrap gap-2">
                                {item.odalar.map(o => (
                                  <span key={o.odaNo}
                                    className="bg-white border border-gray-200 text-gray-600 text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg flex items-center gap-1.5">
                                    {o.odaNo}
                                    <span className="text-indigo-400">×</span>
                                    {o.adet}
                                  </span>
                                ))}
                              </div>
                            ),
                          },
                          {
                            anahtar: 'toplam', baslik: 'Toplam Adet', hizala: 'sag', siralanir: true,
                            ciz: item => <Rozet renk="indigo">{item.toplam} adet</Rozet>,
                          },
                        ]}
                      />
                    </div>
                    {/* Mobil: kartlar */}
                    <div className="sm:hidden flex flex-col divide-y divide-gray-50">
                      {laundryOzet.map(item => (
                        <div key={item.ad} className="p-5 bg-white">
                          <div className="flex items-center justify-between gap-2 mb-3">
                            <p className="font-bold text-gray-800 text-sm tracking-tight">{item.ad}</p>
                            <span className="bg-indigo-50 text-indigo-700 border border-indigo-100 text-[10px] font-black tracking-widest px-3 py-1.5 rounded-xl flex-shrink-0">{item.toplam} ADET</span>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            {item.odalar.map(o => (
                              <span key={o.odaNo} className="bg-gray-50 border border-gray-100 text-gray-600 text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg">
                                {o.odaNo} <span className="text-indigo-400">×</span> {o.adet}
                              </span>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Kirli listesi popup */}
      {kirliModalOda && (
        <KirliListesiModal
          oda={kirliModalOda}
          laundryKalemleri={laundryKalemleri}
          personeller={personeller}
          onClose={() => setKirliModalOda(null)}
          onKaydedildi={() => { fetchVeriler(); }}
        />
      )}

      {/* Arıza Nedeni Modal */}
      {arizaNedenModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[10000] bg-gray-900/40 backdrop-blur-sm animate-fadeIn" onClick={() => setArizaNedenModal(null)}>
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden p-6 w-96 animate-scaleIn" onClick={e => e.stopPropagation()}>
            <div className="flex items-center gap-3 border-b border-gray-100 pb-4 mb-4">
               <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-500 border border-amber-100 flex items-center justify-center text-lg shadow-sm">🔧</div>
               <div>
                  <h3 className="font-black text-gray-800 tracking-tight text-lg">Arıza Kaydı</h3>
                  <p className="text-[10px] font-black text-amber-600/70 uppercase tracking-widest">Odayı arızalı işaretliyorsunuz</p>
               </div>
            </div>
            <p className="text-[11px] font-black uppercase tracking-widest text-gray-400 mb-2">Oda {arizaNedenModal.odaNo} / Açıklama (İsteğe Bağlı)</p>
            <textarea
              autoFocus
              value={arizaNedenInput}
              onChange={e => setArizaNedenInput(e.target.value)}
              placeholder="Sorun nedir? Lütfen detaylandırın..."
              rows={3}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none mb-6 shadow-sm bg-gray-50 focus:bg-white transition-colors"
            />
            <div className="flex gap-3 justify-end">
              <button onClick={() => setArizaNedenModal(null)}
                className="flex-1 py-3 text-[11px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 border border-gray-200 rounded-xl transition-all shadow-sm">
                İptal
              </button>
              <button onClick={() => {
                handleArizaliDegis(arizaNedenModal, true, arizaNedenInput.trim() || null);
                setArizaNedenModal(null);
              }}
                className="flex-1 py-3 text-[11px] font-black uppercase tracking-[0.2em] bg-gradient-to-r from-amber-500 to-orange-500 hover:opacity-90 text-white rounded-xl transition-all shadow-xl hover:-translate-y-1">
                KAYDET
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}